import {
  ArrowRightTwoMd,
  boxShadow,
  Button,
  Commute,
  mediaHelper,
  MOBILE_MAX,
  paletteHelper,
  radiusHelper,
  spacingHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { commutePromptCTAs } from './helpers/commutePrompts';
import { trackModalImpression } from '../../../../../helpers/analytics/trackModalImpression';

const CommuteSearchCTAsWrapper = styled.div`
  background: ${paletteHelper(`backgroundSecondaryBase`)};
  padding: ${spacingHelper('medium')};
  border-radius: ${radiusHelper('extraLarge')};
  margin-top: ${spacingHelper('twoExtraLarge')};
`;

const dangerouslySetClassNames = {
  label: 'search-by-travel-time-button-label',
};

const EmptyCommuteCTA = styled(Button)`
  padding: 0;

  ${typographyHelper('subtitle02')};
  color: ${paletteHelper('textPrimary')};

  &:hover,
  &:focus {
    .${dangerouslySetClassNames.label} {
      color: ${paletteHelper('textSelectedBrand')};
    }
  }

  .${dangerouslySetClassNames.label} {
    display: flex;
    margin-right: 2px;
  }
`;

export interface CommuteSearchCTASProps {
  openCommuteSearch: (commute?: Commute) => void;
}

const StyledCommuteSearchPromptCTA = styled(Button)`
  flex: 1;
  padding-left: 16px;
  ${boxShadow.defaultBoxShadow}
  &:hover {
    ${boxShadow.boxShadowHover};
  }
`;

const CommuteSearchPromptCTAs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacingHelper('extraSmall')};
  width: 100%;
  margin-top: ${spacingHelper('medium')};

  ${mediaHelper('desktopMin')} {
    flex-flow: row wrap;
  }
`;

export const CommuteSearchCTAs: FunctionComponent<CommuteSearchCTASProps> = ({
  openCommuteSearch,
}) => {
  return (
    <CommuteSearchCTAsWrapper>
      <EmptyCommuteCTA
        variant="naked"
        sizeVariant="small"
        icon={<ArrowRightTwoMd />}
        iconPlacement="right"
        dangerouslySetClassNames={dangerouslySetClassNames}
        onClick={() => {
          openCommuteSearch();
          trackModalImpression({
            modalName: 'multi_intent',
            screenName: 'commute_search_point_of_interest_search_screen',
            inPageSource: 'home:search-brick:search-by-travel-time',
            isModalFullscreen: window.innerWidth <= MOBILE_MAX,
          });
        }}
      >
        Try searching by travel time
      </EmptyCommuteCTA>
      <CommuteSearchPromptCTAs>
        {commutePromptCTAs.map((cta, index) => {
          const { commute, ctaLabel } = cta;
          return (
            <StyledCommuteSearchPromptCTA
              key={index}
              variant="secondary"
              icon={cta.icon}
              onClick={() => {
                openCommuteSearch(commute);
                trackModalImpression({
                  modalName: 'multi_intent',
                  screenName: 'commute_search_point_of_interest_search_screen',
                  inPageSource: 'home:search-brick:search-by-travel-time',
                  isModalFullscreen: window.innerWidth <= MOBILE_MAX,
                });
              }}
              sizeVariant="medium"
            >
              {ctaLabel}
            </StyledCommuteSearchPromptCTA>
          );
        })}
      </CommuteSearchPromptCTAs>
    </CommuteSearchCTAsWrapper>
  );
};
